import { render, staticRenderFns } from "./AuthorList.vue?vue&type=template&id=6343bbde"
import script from "./AuthorList.vue?vue&type=script&lang=js"
export * from "./AuthorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports